import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck, Target, Users, Check } from "lucide-react";
import { useI18n } from "@/i18n";
import { useMeta } from "@/lib/useMeta";
import { PublicPage } from "@/components/site";

function Block({ icon: Icon, title, children, testid }) {
  return (
    <section className="grid md:grid-cols-12 gap-6 py-12 border-t border-[var(--line)]" data-testid={testid}>
      <div className="md:col-span-4 flex items-start gap-3">
        <Icon className="text-emerald-400 shrink-0 mt-1" size={22} />
        <h2 className="text-2xl font-semibold">{title}</h2>
      </div>
      <div className="md:col-span-8 space-y-4 text-neutral-300 leading-relaxed">{children}</div>
    </section>
  );
}

export default function About() {
  const { t } = useI18n();
  useMeta(t("meta.about.title"), t("meta.about.desc"), { page: "about" });
  return (
    <PublicPage testid="about-page">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
        <p className="eyebrow mb-4">{t("nav.about")}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold max-w-4xl leading-[1.05]" data-testid="about-title">{t("about.title")}</h1>
        <p className="mt-6 text-base md:text-lg text-neutral-300 max-w-3xl">{t("about.lead")}</p>
        <div className="mt-14">
          <Block icon={Users} title={t("about.storyTitle")} testid="about-story">
            {t("about.story").map((p) => <p key={p}>{p}</p>)}
          </Block>
          <Block icon={Target} title={t("about.missionTitle")} testid="about-mission">
            <p>{t("about.mission")}</p>
          </Block>
          <Block icon={Users} title={t("about.whoTitle")} testid="about-who">
            <ul className="space-y-2.5">
              {t("about.who").map((x) => <li key={x} className="flex gap-2.5"><Check size={18} className="text-emerald-500 shrink-0 mt-0.5" />{x}</li>)}
            </ul>
          </Block>
          <Block icon={ShieldCheck} title={t("about.trustTitle")} testid="about-trust">
            <div className="grid sm:grid-cols-2 gap-4">
              {t("about.trust").map(([h, d]) => (
                <div key={h} className="panel p-5">
                  <h3 className="font-semibold text-white">{h}</h3>
                  <p className="text-sm text-neutral-400 mt-1.5">{d}</p>
                </div>
              ))}
            </div>
          </Block>
        </div>
        <div className="light-panel p-8 sm:p-10 mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
          <div>
            <h2 className="text-xl font-semibold">{t("about.ctaTitle")}</h2>
            <p className="text-sm text-neutral-600 mt-1">{t("about.ctaText")}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/register" className="btn-brand rounded-full px-6 py-3 font-semibold inline-flex items-center gap-2" data-testid="about-cta-register">{t("landing.ctaPrimary")} <ArrowRight size={16} /></Link>
            <Link to="/iletisim" className="rounded-full px-6 py-3 font-semibold border border-neutral-300 text-neutral-800 hover:border-neutral-500" data-testid="about-cta-contact">{t("nav.contact")}</Link>
          </div>
        </div>
      </div>
    </PublicPage>
  );
}
